module.exports = __webpack_public_path__ + "static/media/lock.b9df19a2.svg";